import Box from '@mui/material/Box'

/**
 * Password rule row status glyphs from [Remix Icon](https://remixicon.com/)
 * — System **`checkbox-circle-line`** (met) and **`close-circle-line`** (not met).
 * Paths match the Apache-2.0 SVGs from the official set.
 */

function CheckboxCircleLineGlyph() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      aria-hidden
    >
      <path d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM17.4571 9.45711L16.0429 8.04289L11 13.0858L8.20711 10.2929L6.79289 11.7071L11 15.9142L17.4571 9.45711Z" />
    </svg>
  )
}

function CloseCircleLineGlyph() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      aria-hidden
    >
      <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z" />
    </svg>
  )
}

type Props = {
  met: boolean
  label: string
}

/** Figma: green circle-check vs red circle-x on each “Password must contain” row. */
export function InvitePasswordRuleStatusIcon({ met, label }: Readonly<Props>) {
  const title = met ? `${label} — met` : `${label} — not met`
  return (
    <Box
      component="span"
      title={title}
      role="img"
      aria-label={title}
      sx={{
        width: 16,
        height: 16,
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: met ? '#22c55e' : '#ef4444',
      }}
    >
      {met ? <CheckboxCircleLineGlyph /> : <CloseCircleLineGlyph />}
    </Box>
  )
}
